import React from "react";
import RightCircleIconImage from "../../assets/images/RightCircle.svg";

const RightCircleIcon = ({ onClick = () => {} }) => {
  return (
    <img
      src={RightCircleIconImage}
      alt="Next"
      className="right-circle-icon"
      onClick={onClick}
    />
  );
};

export default RightCircleIcon;
